








import { Component, Vue } from 'vue-property-decorator';
import { userWebservice } from '@/webservices/user';
import { goToMainLink } from '@/helpers/routing/links';
import localforage from 'localforage';

@Component
export default class Logout extends Vue {
    // Mounted is called initially
    private mounted() {
        this.logout();
    }

    // Methods
    private logout() {
        localStorage.clear();
        if (process.env.VUE_APP_STATE_KEY) {
            localforage.removeItem(process.env.VUE_APP_STATE_KEY);
        }
        userWebservice
            .logout()
            .then(() => {
                setTimeout(() => {
                    goToMainLink('logout');
                }, 300);
            })
            .catch((error) => {
                console.log(error);
            });
    }
}
